const data = [{
  Year: 2002,
  Category: 'Media rights',
  'Amount ($M in 2024)': 3.57894336,
}, {
  Year: 2002,
  Category: 'NCAA/Conference distributions',
  'Amount ($M in 2024)': 0.0,
}, {
  Year: 2003,
  Category: 'Media rights',
  'Amount ($M in 2024)': 4.6624149,
}, {
  Year: 2003,
  Category: 'NCAA/Conference distributions',
  'Amount ($M in 2024)': 0.0,
}, {
  Year: 2004,
  Category: 'Media rights',
  'Amount ($M in 2024)': 0.168333,
}, {
  Year: 2004,
  Category: 'NCAA/Conference distributions',
  'Amount ($M in 2024)': 12.36825315,
}, {
  Year: 2005,
  Category: 'Media rights',
  'Amount ($M in 2024)': 0.1770678,
}, {
  Year: 2005,
  Category: 'NCAA/Conference distributions',
  'Amount ($M in 2024)': 15.02459406,
}, {
  Year: 2006,
  Category: 'Media rights',
  'Amount ($M in 2024)': 0.14264096,
}, {
  Year: 2006,
  Category: 'NCAA/Conference distributions',
  'Amount ($M in 2024)': 15.2219837,
}, {
  Year: 2007,
  Category: 'Media rights',
  'Amount ($M in 2024)': 0.0,
}, {
  Year: 2007,
  Category: 'NCAA/Conference distributions',
  'Amount ($M in 2024)': 17.2516545,
}, {
  Year: 2008,
  Category: 'Media rights',
  'Amount ($M in 2024)': 0.0,
}, {
  Year: 2008,
  Category: 'NCAA/Conference distributions',
  'Amount ($M in 2024)': 15.67910058,
}, {
  Year: 2009,
  Category: 'Media rights',
  'Amount ($M in 2024)': 0.0,
}, {
  Year: 2009,
  Category: 'NCAA/Conference distributions',
  'Amount ($M in 2024)': 16.5235069,
}, {
  Year: 2010,
  Category: 'Media rights',
  'Amount ($M in 2024)': 0.0,
}, {
  Year: 2010,
  Category: 'NCAA/Conference distributions',
  'Amount ($M in 2024)': 16.2793917,
}, {
  Year: 2011,
  Category: 'Media rights',
  'Amount ($M in 2024)': 0.0,
}, {
  Year: 2011,
  Category: 'NCAA/Conference distributions',
  'Amount ($M in 2024)': 14.04980898,
}, {
  Year: 2012,
  Category: 'Media rights',
  'Amount ($M in 2024)': 0.0,
}, {
  Year: 2012,
  Category: 'NCAA/Conference distributions',
  'Amount ($M in 2024)': 20.7790419824,
}, {
  Year: 2013,
  Category: 'Media rights',
  'Amount ($M in 2024)': 0.0,
}, {
  Year: 2013,
  Category: 'NCAA/Conference distributions',
  'Amount ($M in 2024)': 28.7540215,
}, {
  Year: 2014,
  Category: 'Media rights',
  'Amount ($M in 2024)': 0.0,
}, {
  Year: 2014,
  Category: 'NCAA/Conference distributions',
  'Amount ($M in 2024)': 29.59748762,
}, {
  Year: 2015,
  Category: 'Media rights',
  'Amount ($M in 2024)': 22.328295,
}, {
  Year: 2015,
  Category: 'NCAA/Conference distributions',
  'Amount ($M in 2024)': 11.33688541,
}, {
  Year: 2016,
  Category: 'Media rights',
  'Amount ($M in 2024)': 25.3310408,
}, {
  Year: 2016,
  Category: 'NCAA/Conference distributions',
  'Amount ($M in 2024)': 10.9314452,
}, {
  Year: 2017,
  Category: 'Media rights',
  'Amount ($M in 2024)': 26.7385792,
}, {
  Year: 2017,
  Category: 'NCAA/Conference distributions',
  'Amount ($M in 2024)': 12.84594176,
}, {
  Year: 2018,
  Category: 'Media rights',
  'Amount ($M in 2024)': 27.35992792,
}, {
  Year: 2018,
  Category: 'NCAA/Conference distributions',
  'Amount ($M in 2024)': 12.82594992,
}, {
  Year: 2019,
  Category: 'Media rights',
  'Amount ($M in 2024)': 28.96924648,
}, {
  Year: 2019,
  Category: 'NCAA/Conference distributions',
  'Amount ($M in 2024)': 14.36863174,
}, {
  Year: 2020,
  Category: 'Media rights',
  'Amount ($M in 2024)': 30.04601578,
}, {
  Year: 2020,
  Category: 'NCAA/Conference distributions',
  'Amount ($M in 2024)': 11.38161453,
}, {
  Year: 2021,
  Category: 'Media rights',
  'Amount ($M in 2024)': 19.57146705,
}, {
  Year: 2021,
  Category: 'NCAA/Conference distributions',
  'Amount ($M in 2024)': 4.6616239,
}, {
  Year: 2022,
  Category: 'Media rights',
  'Amount ($M in 2024)': 25.432575,
}, {
  Year: 2022,
  Category: 'NCAA/Conference distributions',
  'Amount ($M in 2024)': 14.4626307,
}, {
  Year: 2023,
  Category: 'Media rights',
  'Amount ($M in 2024)': 25.97821068,
}, {
  Year: 2023,
  Category: 'NCAA/Conference distributions',
  'Amount ($M in 2024)': 8.86359294,
}];

export default data;
